export const useGetCurrentFabricShowTabs = ({
  product,
}:{
  product: any,
}) => {
  // 第一个 tab 的 fabric 选项`
  const fabricAmpProOptions = product?.ampProtOption?.items?.find((item: any) => {
    return item?.label === "Fabric"
  })?.values?.map((value:any) => {
    return value?.label
  }) as string[]

  // 第二个 tab 的 fabric 选项
  const available_product_fabric_configurable_options = product?.available_product?.configurable_options?.find((item: any) => {
    return item?.label === "Fabric"
  })?.values?.map((value:any) => {
    return value?.label
  }) as string[]

  // 选择哪些 fabric 的时候显示 tab
  const currentFabricArrayShowTabs: string[] = fabricAmpProOptions?.filter((item:any) => {

    if (!available_product_fabric_configurable_options) {
      return fabricAmpProOptions
    }

    const isVaildArray = Array.isArray(available_product_fabric_configurable_options) && available_product_fabric_configurable_options.length > 0

    if (!isVaildArray) {
      return fabricAmpProOptions
    }
    
    return available_product_fabric_configurable_options?.includes(item.replace("-default", ""))
  })

  // 给第二个 tabs 创建 button 切换到第一个 tabs
  const buttonThatDoNotExistFabricArray = fabricAmpProOptions?.filter((item:any) => {

    if (!available_product_fabric_configurable_options) {
      return []
    }

    if (Array.isArray(available_product_fabric_configurable_options) && available_product_fabric_configurable_options.length === 0) {
      return []
    }
    
    return !available_product_fabric_configurable_options?.includes(item.replace("-default", ""))
  })

  return {
    currentFabricArrayShowTabs,
    buttonThatDoNotExistFabricArray
  }
}
